import { BUTTON_SECTION_HEIGHT_PERCENTEGES, device } from 'constants/index';
import styled from 'styled-components';
import { Button } from 'components/Button/Button';

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  margin-top: 160px;
  padding: 0 100px;
  @media ${device.md} {
    padding: 0 30px;
    justify-content: flex-end;
    padding-bottom: 6%;
  }
`;

const BigText = styled.p`
  width: 670px;
  color: #1C1C1C;
  font-size: 64px;
  font-style: normal;
  font-weight: 500;
  line-height: 80px;
  @media ${device.md} {
    font-size: 34px;
    line-height: 46px;
    width: 100%;
  }
`

const SmallText = styled.p`
  margin-top: 40px;
  color: #989898;
  font-size: 25px;
  font-style: normal;
  line-height: 30px;
  font-family: "Dexa Pro";
  font-weight: 300;
  @media ${device.md} {
    margin-top: 20px;
    font-size: 20px;
    line-height: 30px;
    width: 100%;
  }
`

const StartButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 12px 25px;
  max-width: 200px;
  margin-top: 60px;
  @media ${device.md} {
    max-width: 100%;
  }
`

const ButtonText = styled.span``

const ButtonContent = styled.div``

export { 
  Wrapper,
  BigText,
  SmallText,
  StartButton,
  ButtonText,
  ButtonContent
};
